'use client'

import React, { useEffect } from 'react'

import { reportTelemetryError } from '@/utilities/telemetry'

// Root error boundary — catches errors thrown in the root layout itself, which
// the segment error.tsx cannot. Must render its own <html>/<body>. Reports to
// RUM before showing a minimal fallback.
export default function GlobalError({
  error,
  reset,
}: {
  error: Error & { digest?: string }
  reset: () => void
}) {
  useEffect(() => {
    reportTelemetryError(error, { digest: error.digest, boundary: 'global' })
  }, [error])

  return (
    <html lang="pl">
      <body
        style={{
          fontFamily: 'system-ui, sans-serif',
          minHeight: '100dvh',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          padding: '2rem',
        }}
      >
        <div style={{ textAlign: 'center', maxWidth: '32rem' }}>
          <h1 style={{ fontSize: '1.75rem', fontWeight: 700 }}>Coś poszło nie tak</h1>
          <p style={{ marginTop: '0.75rem', color: '#475569' }}>
            Wystąpił nieoczekiwany błąd. Spróbuj odświeżyć stronę.
          </p>
          <button
            onClick={reset}
            style={{
              marginTop: '1.5rem',
              background: '#dc2626',
              color: '#fff',
              padding: '0.75rem 1.5rem',
              borderRadius: '0.75rem',
              fontWeight: 700,
              border: 'none',
              cursor: 'pointer',
            }}
          >
            Spróbuj ponownie
          </button>
        </div>
      </body>
    </html>
  )
}
